export const accountManagement = [
  { label: "My Account", value: "myAccount" },
  { label: "Change Password", value: "changePassword" },
  { label: "Admin User", value: "adminUser" },
  { label: "Provider User", value: "providerUser" },
  { label: "Staff User", value: "staffUser" },
  { label: "Roles", value: "roles" },
  { label: "Roles & Responsibility", value: "rRes" },
];

export const master = [
  { label: "Data Import", value: "dataImport" },
  // { label: "Drug Catalogue", value: "drugCatalogue" },
  { label: "ICD 10 Code", value: "icd10Code" },
  { label: "DSM Code", value: "dsmCode" },
  { label: "Order Status", value: "orderStatus" },
  { label: "Order Types", value: "orderTypes" },
  { label: "Task Type", value: "taskType" },
  { label: "Incident Location", value: "incidentLocation" },
  { label: "Primary Treating Clinician", value: "primaryTreatingClinician" },
  { label: "Unit Designation", value: "unitDesignation" },
];

export const communications = [
  { label: "Email Templates", value: "emailTemplate" },
  { label: "SMS Templates", value: "smsTemplate" },
  { label: "Discharge Instructions", value: "notesTemplate" },
  { label: "Communication Rule", value: "communicationRule" },
];

export const roles = [
  { label: "Admin", value: "Admin" },
  { label: "Super Admin", value: "SuperAdmin" },
];

export const DRUG_CATALOGUE_DATA = {
  DRUG_NAME: "drugName",
  DRUG_TYPE: "drugType",
};
